"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Page = _interopRequireDefault(require("@sprinx/react-mui-layout/Page"));

var _PageHeadline = _interopRequireDefault(require("@sprinx/react-mui-layout/PageHeadline"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _HomeOutlined = _interopRequireDefault(require("@material-ui/icons/HomeOutlined"));

var _NavigateNext = _interopRequireDefault(require("@material-ui/icons/NavigateNext"));

var _PageBanner = _interopRequireDefault(require("../../components/PageBanner"));

var _PageBreadcrumbsItem = _interopRequireDefault(require("../../components/PageBreadcrumbsItem"));

var _HtmlHead = _interopRequireDefault(require("../../components/HtmlHead/HtmlHead"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../../withNullIfStaticBuild"));

var _StructuredDataBreadcrumbs = _interopRequireDefault(require("../../components/StructuredDataBreadcrumbs"));

var _CatalogueSubCategories = _interopRequireDefault(require("./components/CatalogueSubCategories"));

var _CatalogueProductList = _interopRequireDefault(require("./components/CatalogueProductList"));

var CatalogueProductList = (0, _withNullIfStaticBuild.default)(_CatalogueProductList.default);
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(2)
    },
    container: {
      width: '100%'
    }
  };
}, {
  name: 'CataloguePageLayout'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_NavigateNext.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_PageBanner.default, {
  position: "catalogueTop",
  hideSkeleton: true
});

function CataloguePageLayout(_ref) {
  var catalogueTaxonomy = _ref.catalogueTaxonomy,
      pClasses = _ref.classes,
      className = _ref.className,
      PageProps = _ref.PageProps;
  var t = (0, _useTranslate.default)();
  var breadcrumbs = catalogueTaxonomy.breadcrumbs,
      htmlHead = catalogueTaxonomy.htmlHead,
      subCategories = catalogueTaxonomy.subCategories,
      taxonomy = catalogueTaxonomy.taxonomy,
      title = catalogueTaxonomy.title;
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(_Page.default, (0, _extends2.default)({}, PageProps, {
    classes: {
      content: classes.container
    },
    className: (0, _clsx.default)(classes.root, className),
    BreadcrumbsProps: {
      separator: _ref2,
      disableHistory: true,
      disableHome: true
    },
    breadcrumbItems: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
      Icon: _HomeOutlined.default,
      label: t('globalNavigation/home'),
      to: '/'
    }), typeof breadcrumbs !== 'undefined' && breadcrumbs.map(function (b, idx) {
      return /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
        key: idx,
        label: t(b.label, {
          acceptString: true
        }),
        to: b.href
      });
    }))
  }), /*#__PURE__*/_react.default.createElement(_StructuredDataBreadcrumbs.default, {
    breadcrumbs: breadcrumbs
  }), htmlHead && /*#__PURE__*/_react.default.createElement(_HtmlHead.default, {
    htmlHead: htmlHead
  }), _ref3, /*#__PURE__*/_react.default.createElement(_PageHeadline.default, null, title), /*#__PURE__*/_react.default.createElement(_CatalogueSubCategories.default, {
    subCategories: subCategories
  }), /*#__PURE__*/_react.default.createElement(CatalogueProductList, {
    taxonomyCode: taxonomy
  }));
}

process.env.NODE_ENV !== "production" ? CataloguePageLayout.propTypes = {
  catalogueTaxonomy: _propTypes.default.shape({
    breadcrumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
      href: _propTypes.default.string,
      label: _propTypes.default.string
    })),
    htmlHead: _propTypes.default.shape({
      canonical: _propTypes.default.string,
      meta: _propTypes.default.arrayOf(_propTypes.default.shape({
        content: _propTypes.default.string,
        name: _propTypes.default.string
      })),
      title: _propTypes.default.string
    }),
    subCategories: _propTypes.default.arrayOf(_propTypes.default.shape({
      href: _propTypes.default.string,
      title: _propTypes.default.string
    })),
    taxonomy: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  PageProps: _propTypes.default.shape({})
} : void 0;
CataloguePageLayout.defaultProps = {
  classes: undefined,
  className: undefined,
  PageProps: undefined
};
var _default = CataloguePageLayout;
exports.default = _default;